<template>
  <div class="crm-query-container" v-if="de">
    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ tableText }}
        </label>
        <div class="selection">{{ de.object ? label : "" }}</div>
      </div>

      <div class="field-container">
        <label class="query-label">
          {{ $t("limit") }}
        </label>
        <div class="selection">{{ de.limit ? de.limit : "" }}</div>
      </div>
    </div>

    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ $t("fields") }}
        </label>
        <div class="selected-fields">
          <ul>
            <li v-for="field in selectedFields" :key="field.name">
              {{ field.label }}
            </li>
          </ul>
        </div>
      </div>

      <div class="field-container">
        <label class="query-label">
          {{ $t("sort") }}
        </label>
        <div class="selected-fields">
          <ul>
            <li v-for="field in sorts" :key="field.name">
              <span class="key-label">{{ field.key.label }}</span>
              <span class="sort-dir">{{ field.sortDir.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="query-detail-row">
      <div class="where-field-container">
        <label class="query-label">
          {{ $t("where") }}
        </label>
        <div class="selected-fields">
          <where-group-view :data-element="de" :clauses="clauses" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import WhereGroupView from "@/components/queries/crm-queries/WhereGroupView";
  import NitroDataCache from "@/utils/nitro-data-cache";

  export default {
    name: "NitroView",
    components: {
      WhereGroupView
    },
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      tableText() {
        return this.$t("table");
      },
      de() {
        let elem = this;
        let app = elem.apps.find(app => {
          return app.uuid === elem.appId;
        });

        return app.dataElements[elem.deId];
      },
      selectedFields() {
        if (!this.de.fields) {
          return [];
        }

        return Object.keys(this.de.fields).map(key => {
          return {
            name: key,
            label: this.de.fields[key].label
          };
        });
      },
      sorts() {
        return this.de.sort || [];
      },
      clauses() {
        return this.de.where || {};
      },
      label() {
        let label = "";
        if (this.filteredObjects.length > 0) {
          let nitroObject = this.filteredObjects.find(
            object => object.name === this.de.object.name
          );
          if (nitroObject !== undefined) {
            label = nitroObject.label;
          }
        }
        return label;
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        NitroDataCache.fetchAvailableTables().then(
          res => {
            this.filteredObjects = res;
          },
          () => {
            this.filteredObjects = [];
          }
        );
      }
    },
    data() {
      return {
        filteredObjects: []
      };
    }
  };
</script>

<style scoped>
  .selected-fields {
    display: inline-block;
    flex-basis: 80%;
  }

  .selected-fields ul {
    list-style-type: none;
    padding-left: 0;
  }

  .selected-fields li {
    display: flex;
  }

  .selected-fields .key-label {
    flex-basis: 50%;
  }

  .selected-fields .sort-dir {
    flex-basis: 50%;
  }

  .selected-fields .clause-label {
    flex-basis: 30%;
  }

  .selected-fields .operator {
    flex-basis: 20%;
  }

  .selected-fields .clause-value {
    flex-basis: 50%;
  }

  .field-container {
    display: flex;
    flex-basis: 50%;
  }

  .selection {
    display: inline-block;
  }

  .query-detail-row {
    display: flex;
  }

  .query-label {
    font-size: 0.85rem;
    font-weight: bold;
    flex-basis: 20%;
  }
  .where-field-container {
    display: flex;
    width: 100%;
  }
  .where-field-container .query-label {
    flex-basis: 10%;
  }
  .where-field-container .selected-fields {
    flex-basis: 90%;
  }
</style>
